import {
  SET_COMPLIANCE_SELECTED_TASK,
  SET_COMPLIANCE_TASK_STATUS,
  SET_COMPLIANCE_VERSION_HISTORY,
} from "constants/task/esgCompliance/esgComplianceTaskConst";

const initial_state = {
  esgComplianceSelectedTask: null,
  esgComplianceMertic: [],
  esgComplianceVersion: [],
};

export default function reducer(state = initial_state, action) {
  switch (action.type) {
    case "RESET_STATE":
      return (state = {
        ...state,
        ...initial_state,
      });
    case SET_COMPLIANCE_SELECTED_TASK:
      return (state = {
        ...state,
        esgComplianceSelectedTask: action.payload,
      });
    case SET_COMPLIANCE_TASK_STATUS:
      return (state = {
        ...state,
        esgComplianceMertic: action.payload,
      });
    case SET_COMPLIANCE_VERSION_HISTORY:
      return (state = {
        ...state,
        esgComplianceVersion: action.payload,
      });
    default:
      return state;
  }
}
